<template>
    <div class="box">
      <a-row :gutter="24">
        <a-col :md="24">
          <a-card>
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="24">
                  <a-col :md="6">
                    <a-form-item label="工艺名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入工艺名称" v-model="queryParam.craftName"></a-input>
                    </a-form-item>
                    
                  </a-col>
                  
                  <a-col :md="6">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-col :md="6" :sm="24">
                        <a-button type="primary" @click="searchQuery">查询</a-button>
                        <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                      </a-col>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator"  style="margin-top: 5px">
              <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
            </div>
  
            <!-- table区域-begin -->
            <div>
              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="uuid"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                @change="handleTableChange">
                <span slot="action" slot-scope="text, record">
                  <a @click="bindProcess(record)">选择工序</a>
                  <a-divider type="vertical" />
                  <a @click="bindCategory(record)">选择类别</a>
                  <a-divider type="vertical" />
                  <a @click="handleEdit(record)">编辑</a>
                  <!-- <a-divider type="vertical" />
                  <a @click="getDetail(record)">查看</a> -->
                  <a-divider type="vertical" />
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </span>
              </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <!-- 新增/编辑区域 -->
      <!-- 绑定工序 -->
      <bind-process ref="bindProcessRef"  @ok="bindProcessOk" @close="bindProcessClose"></bind-process>
      <add-craft ref="addCraftRef" @ok="addCraftOk" @close="addCraftClose"></add-craft>
      <bind-category ref="bindCategoryRef"  @ok="bindCategoryOk" @close="bindCategoryClose"></bind-category>
    </div>
  </template>
  
  <script>
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import { queryEnableDictItemsByCode } from '@/api/identifierCode/identifierCode'
    import BindProcess from './modules/bindProcess.vue'
    import BindCategory from './modules/BindCategory.vue'
    import addCraft from './modules/addCraft.vue'
    import { getCraftAll, delCraft } from '@/api/api'
    export default {
      name: "list",
      mixins:[JeecgListMixin],
      components: {
        addCraft,
        BindCategory,
        BindProcess
      },
      data() {
        return {
          current: ['enterpriseRule'], // 顶部导航栏
          bindInfo:{},
          // 查询区域布局
          labelCol: {
            span: 5
          },
          wrapperCol: {
            span: 18,
            offset: 1
          },
  
          // 查询条件
          queryParam: {
            craftName: '',
            isStandard: '1'
          },
          // 表头
          columns: [
            {
              title: '序号',
              dataIndex: '',
              key:'rowIndex',
              width: '50px',
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {title: '工艺名称 ', dataIndex: 'craftName', align:"center",},
            {title: '工艺编码 ', dataIndex: 'craftCode', align:"center",},
            // {title: '工序 ', dataIndex: 'codeRuleId', align:"center",},
            // {title: '类别 ', dataIndex: 'formTemplateId', align:"center",},
            {
              title: '操作',
              dataIndex: 'action',
              width: '30%',
              align:"center",
              scopedSlots: { customRender: 'action' },
            },
          ],
          ipagination: {
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '20', '30'],
            showTotal: (total, range) => {
                return range[0] + '-' + range[1] + ' 共' + total + '条'
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
          },
          // 控制列的显示状态
          columnVisibility: {
            codeRuleId: false, // 设置为 false 隐藏该列
            formTemplateId: false, // 设置为 false 隐藏该列
            proceCode: false
          },
          // url: {
          //   list: "/process/getAll",
          //   delete: "/codeRules/fzRule/delete",
          //   deleteBatch: "/codeRules/fzRule/deleteBatch"
          // },
          visibleRuleNode: false, // 规则节点抽屉开关
          uuid: '', // 每一项的uuid
  
          // 下拉框数据
          ruleSystem: [], // 发码机构
          ruleCategory: [], // 参考标准
          ruleLabel: [] // 类别
        }
      },
      computed: {
        filteredColumns() {
          return this.columns.filter(column => {
            if (column.dataIndex in this.columnVisibility) {
              return this.columnVisibility[column.dataIndex];
            }
            return true;
          });
        }
      },
      created() {
        // 获取列表
        this.getCraftList()
      },
      methods: {
        searchQuery(){
          this.getCraftList(this.queryParam.craftName)
        },
        searchReset(){
          this.getCraftList()
          this.queryParam.craftName = ''
        },
        async getCraftList(name){
          let pageNo = this.ipagination.current
          let pageSize = this.ipagination.pageSize
          const params = {
            craftCode: '',
            craftName: name || '',
            segmentType: 1,
            pageNo: pageNo,
            pageSize: pageSize,
          }
          const res = await getCraftAll(params)
          if( res.code == 200 && res.success == true ){
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          }
        },
        handleTableChange(pagination, filters, sorter) {
            this.ipagination.current = pagination.current;
            this.ipagination.pageSize = pagination.pageSize;

            // 如果需要处理排序或过滤，可以在这里添加逻辑
            const name = this.queryParam.craftName
            this.getCraftList(name);
        },
        // 
        modalFormOk(){
          this.loadData()
        },
        modalFormClose(){

        },
        bindRuleListOk(){

        },
        bindCategoryOk(){
          
        },
        bindCategoryClose(){

        },
        addCraftOk(){
          this.getCraftList()
        },
        addCraftClose(){

        },
        handleAdd(){
          this.$refs.addCraftRef.add()
        },
        handleEdit(record){
            this.$refs.addCraftRef.edit(record)
        },
        // 绑定工序
        bindProcess(record){
            this.$refs.bindProcessRef.open(record)
        },
        // 绑定类别
        bindCategory(record){
          this.$refs.bindCategoryRef.open(record)
        },
        chooseTemplateOk(){
          this.loadData()
        },
        onCodeRuleIdUpdate(newId){
            this.codeRuleId = newId;
            console.log('新的规则ID:', newId);
        },
        onTraceTemplateIdUpdate(newId){
            this.formTemplateId = newId;
            console.log('新的模版ID:', newId);
        },
        handleSubComponentClose() {
            this.loadData(); // 刷新父组件数据
        },
        handleTraceTemplateClose() {
            this.loadData(); // 刷新父组件数据
        },
        bindTemplateOk(){
          this.loadData()
        },
        // 规则节点抽屉变化事件
        afterVisibleChange(val) {
          console.log('visible', val)
  
        },
        // 规则节点抽屉关闭 - 点击事件
        onClose() {
          this.visibleRuleNode = false;
        },
        begin(record){
            this.$refs.BeginDialogRef.open(record.codeRuleId)
            
        },
        // 删除
        async handleDelete(id){
          const params = {
            id: id
          }
          const res = await delCraft(params)
          if( res.code == 200 && res.success == true ){
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error('删除失败')
          }
        },
        // 查看详情
        getDetail(){
          this.$refs.traceListRef.show()
        },
        showTotal(total) {
          return `共 ${total} 条`;
        },
  
      },
      watch: {
        current() {
          this.queryParam.isStandard = this.current[0] === 'enterpriseRule' ? '1' : '0' // 规则查询参数
          this.loadData(1)
        }
      },
      
    }
  </script>
  
  <style scoped>
    @import '~@assets/less/common.less'
  </style>